import { JobItemType } from '../../../common/types'
import { JobItemInput } from '../../../components/TowingRecordItems/types'

export function splitOrderItems(
  orderItems: JobItemInput[] = [],
  discountItemFromApi: JobItemInput | null = null
): { orderItems: JobItemInput[]; discountItem: JobItemInput | null } {
  const discountItem =
    discountItemFromApi ?? orderItems.find(item => item.type === JobItemType.discount) ?? null

  const lines = orderItems.filter(
    item =>
      item.type === JobItemType.normal ||
      item.type === JobItemType.automatic ||
      item.type === JobItemType.generated
  )

  return { orderItems: lines, discountItem }
}
